import React from 'react'
// CopyRight Area
const CopyRight = () => {
    return (
        <>
            <div id="copy_right">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="copy-right-area">
                                <p>Copyright @{new Date().getFullYear()} <span>ULD Logistics & Distribution Sdn. Bhd. (1459238-K)</span> All Rights Reserved </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CopyRight
